<template>
  <div class="usage-summary-table">
    <DetailList :rows="rows" :hide-first-row-top-border="true" />
  </div>
</template>

<script>
import DetailList from "@/components/GenericComponents/DetailList.vue";

export default {
  name: "UsageSummaryTable",
  components: { DetailList },
  props: {
    stats: {
      type: Object,
      required: true,
      // { writes, deletes, storageBytesDelta, approxCostUSD, day?, orgId? }
    },
    title: {
      type: String,
      default: "",
    },
  },
  mounted() {
    try {
      // Helps debug zeros displayed in UI
      console.log("UsageSummaryTable.mounted:stats", this.stats);
    } catch (_) {}
  },
  computed: {
    rows() {
      const kb = (Number(this.stats?.storageBytesDelta || 0) / 1024).toFixed(1);
      const formatEUR = (val) => {
        const n = Number(val);
        if (!isFinite(n)) return "—";
        if (n === 0) return "€0.00";
        return Math.abs(n) < 0.01 ? `€${n.toFixed(6)}` : `€${n.toFixed(2)}`;
      };
      return [
        { col1: "Usage", col2: String(this.stats?.writes || 0) },
        { col1: "Deletes", col2: String(this.stats?.deletes || 0) },
        { col1: "Δ Storage (KB)", col2: kb },
        {
          col1: "Approx Cost (EUR)",
          col2:
            typeof this.stats?.approxCostEUR === "number"
              ? formatEUR(this.stats.approxCostEUR)
              : "—",
        },
      ];
    },
  },
};
</script>

<style scoped>
.usage-summary-table {
  margin-top: var(--space-4);
}
</style>
